import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router }  from 'react-router-dom';
import { Provider } from "react-redux";
import store  from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  // </React.StrictMode>
);

